import React from 'react'
import { DataOverview } from './data-overview';
import { SearchBar } from './search-bar';
import { PermissionTableList } from './permission-table-list';
import { agentPermissionHooks } from '@/manager';

/** 智能体权限管理 */
export const AgentDashboardPermission: React.FC = () => {

  const {
    permissionList,
    loading,
    search,
    changePage,
    searchFormData,
    changeSearchForm,
    resetAndSearch
  } = agentPermissionHooks.usePermissionData();

  return (
    <div className='w-full h-full flex flex-col overflow-hidden gap-6'>
      <DataOverview />
      <SearchBar
        search={search}
        searchFormData={searchFormData}
        changeSearchForm={changeSearchForm}
        resetAndSearch={resetAndSearch}
      />
      <PermissionTableList
        permissionList={permissionList}
        loading={loading}
        total={searchFormData.total}
        page={searchFormData.page}
        pageSize={searchFormData.pageSize}
        changePage={changePage}
        search={search}
      />
    </div>
  )
}
